import { render, staticRenderFns } from "./QualityChartPerson.vue?vue&type=template&id=4b96c2be&scoped=true&"
import script from "./QualityChartPerson.vue?vue&type=script&lang=js&"
export * from "./QualityChartPerson.vue?vue&type=script&lang=js&"
import style0 from "./QualityChartPerson.vue?vue&type=style&index=0&id=4b96c2be&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b96c2be",
  null
  
)

export default component.exports